// src/Messanger/api.js
import axiosInstance from "../lib/axios";

export const api = axiosInstance;
export default axiosInstance;